import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const ExportMap = ({
  isOpen,
  handleOnClose,
  handleCancelExport,
  handleExport,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="export-map" data-testid="delete-modal-content">
        <h3 className="title">Export Map</h3>
        <div className="paragraph">
          Are you sure you want to export the map?
          {/* <p className="warning">
            Deleting this farm also includes its corresponding fields. This
            action is cannot be undone.
          </p> */}
        </div>
        <div className="actions-button">
          <Button
            type="solid"
            color="green"
            label="Yes, continue"
            block
            onClick={handleExport}
          />
          <Button
            type="outlined"
            color="white"
            label="Cancel"
            block
            onClick={handleCancelExport}
          />
        </div>
      </div>
    </CustomModal>
  );
};

ExportMap.propTypes = {
  farmInfo: PropTypes.shape({
    farm_id: PropTypes.number.isRequired,
    farm_name: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleCancelExport: PropTypes.func.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  handleExport: PropTypes.func.isRequired,
};

export default ExportMap;
